import { EmptyIndicator } from '@tom-ui/ui'
import dayjs from 'dayjs'

export const formatStringDate = (stringDate: string | undefined | null): string => {
  const date = stringDate && dayjs(stringDate).isValid() ? new Date(stringDate) : undefined

  return date ? `${date.toLocaleDateString()}, ${formatTime(date)}` : EmptyIndicator
}

export const getCompleteDate = (date?: string | null, time?: string | null): string => {
  const completeDate = dayjs(date)
  let hours = 0
  let minutes = 0

  if (!!time && dayjs(time).isValid()) {
    hours = dayjs(time).get('hours')
    minutes = dayjs(time).get('minutes')
  }

  return completeDate.set('hours', hours).set('minutes', minutes).toISOString()
}

export const formatTime = (time: string | null | undefined | Date): string => {
  if (!time) return EmptyIndicator

  const date = new Date(time)
  const formattedTime = date.toLocaleTimeString([], { timeStyle: 'short', hour12: false })

  return formattedTime
}
